import React,{useRef,useEffect,useState, useCallback} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'
import CreateEditAccount from '../salesman/CreateEditSalesman';
import DeleteIcon from '@mui/icons-material/Delete';
import SellIcon from '@mui/icons-material/Sell';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CssBaseline from '@mui/material/CssBaseline';

// Icons
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SyncIcon from '@mui/icons-material/Sync';
import TimerSharpIcon from '@mui/icons-material/TimerSharp';
import EmailSharpIcon from '@mui/icons-material/EmailSharp';
import ViewUserSyncLogsFunctions from "./ViewUserSyncLogsFunctions";


const drawerWidth = 300;



const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    
  return formData;
}, new FormData());


function ViewUserDaysWithSyncLogsFunctions(props) {
    const classes = useStyles();

    const [isLoading, setIsLoading] = useState(true)
    const [syncLogFunctionsData, setSyncLogFunctionsData] = useState([]);
    const requestInProgress = useRef(false);
    const lastSyncLogsFunctionsElementObserver = useRef()
    const [pageNumber,setPageNumber] = useState(1)
    const [hasMoreSyncLogsToLoad, setHasMoreSyncLogsToLoad] = useState(true)
    const [hasLoadingMore, setHasLoadingMore] = useState(false)
    const [openSyncLogsFunctionDialog, setOpenSyncLogsFunctionDialog] = useState(false)
    const [selectedUser, setSelectedUser] = useState();
    const [selectedUserAnchorElement,setSelectedUserAnchorElement] = useState(null)
    const [syncLogsActions, setSyncLogsActions] = useState("");


    const lastSyncLogsElement = useCallback(node=>{
        if(isLoading){
            return
        }
        if(lastSyncLogsFunctionsElementObserver.current){
          lastSyncLogsFunctionsElementObserver.current.disconnect()
        }
        lastSyncLogsFunctionsElementObserver.current = new IntersectionObserver(entries=>{
          if(entries[0].isIntersecting && hasMoreSyncLogsToLoad){
            
            lastSyncLogsFunctionsElementObserver.current.disconnect()
            setPageNumber(prevPageNumber => prevPageNumber + 1)
            setHasLoadingMore(true)
            setIsLoading(true)
          }
    
        })
        
        if(node){
          lastSyncLogsFunctionsElementObserver.current.observe(node)
        }
    },[isLoading, hasMoreSyncLogsToLoad])
    
    useEffect(() => {
           
        if (!isLoading || requestInProgress.current) {
          return;
        }
    
        const fetchSyncLogFunctions = async () => {
          requestInProgress.current = true;
    
          const options = {
            method: 'POST',
            url: '/TransactiSellerSyncLogs/getTransactiSellerUserDaysWithSynclog.json',
            data: objectToFormData({ selected_user_id: props.selectedUser.user_id,page_number: pageNumber, start_date:props.selectedUser.selected_start_date, end_date:props.selectedUser.selected_end_date}),
          };
    
          await axios(options)
          .then((res) => {
            requestInProgress.current = false;
            setIsLoading(false)
            setHasLoadingMore(false)

            const is_success = res.data.response.is_success

            if(!is_success) {

            }

            const sync_logs_data = res.data.response.SyncLogs;
            setHasMoreSyncLogsToLoad(sync_logs_data.length > 0)
            setSyncLogFunctionsData(syncLogFunctionsData.concat(sync_logs_data))

          })
          .catch((error) => {
            requestInProgress.current = false;
          })
        };
    
        fetchSyncLogFunctions();
    }, [isLoading, props]);

   
    const syncLogFunctions = () => {
        return (
            <>
            {
              syncLogFunctionsData.map((syncLogFunction, index) => (
                <React.Fragment key={syncLogFunction.id + "userSynclogFunctions"}>
                  <ListItem 
                    ref={index === syncLogFunctionsData.length - 1 ? lastSyncLogsElement : null} 
                    divider 
                    onClick={(event) => {
                      setSelectedUser(syncLogFunction);
                      setSelectedUserAnchorElement(event.currentTarget);
                      setSyncLogsActions("view_functions");
                      setOpenSyncLogsFunctionDialog(true);
                    }}
                    style={index !== syncLogFunctionsData.length - 1 ? { boxShadow: 'none !important' } : null}
                    key={syncLogFunction.id + "userSynclogFunctions"}
                  >
                    {syncLogFunctionsElement(syncLogFunction)}
                  </ListItem>
                </React.Fragment>
              ))
            }
            </>
        )
    }
    

    const syncLogFunctionsElement = (syncLogFunctions) => {
        return (
          <div>
            <Typography variant="body1" gutterBottom>
            {formatDateToReadableFormat(syncLogFunctions.sync_started)}
            </Typography>
            <Grid container spacing={1} alignItems="center">
              <Grid item>
               {syncLogFunctions.count_user_sync_with_date}  <b>sync</b>
              </Grid>
            </Grid>
          
          </div>
        );
      }

    const syncLogFunctionsLists = () => {
        return(
            <React.Fragment>
            <CssBaseline /> 
              {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
              {syncLogFunctions()}
              {hasLoadingMore ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
            </React.Fragment>
          )
    }
    
    const formatDateTimeToReadableFormat = (date) => {
        const inputDate = new Date(date);

        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        };

        const formattedDate = inputDate.toLocaleString('en-US', options);

        return formattedDate;
    }

    const getSyncTimeInterval = (sync_start_date, sync_end_date) => {

      const startDate = new Date(sync_start_date);
      const endDate = new Date(sync_end_date);

      // Calculate the difference in milliseconds
      const timeDifference = endDate - startDate;

      // Convert milliseconds to minutes
      const intervalInMinutes = timeDifference / (1000 * 60);

      return intervalInMinutes;

    }

    const formatDateToReadableFormat = (date) => {
        const inputDate = new Date(date);

        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        };

        const formattedDate = inputDate.toLocaleString('en-US', options);

        return formattedDate;
    }
    
    return (
        <div>
            
           <Dialog 
            fullScreen 
            open={props.openSyncLogsFunctionDialog} 
            onClose={()=>{props.setOpenSyncLogsFunctionDialog(false)}} 
            TransitionComponent={Transition}
            >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            props.setOpenSyncLogsFunctionDialog(false)
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                       { "Sync logs functions"} <br/>
                       { props.selectedUser.username}
                    </Typography>
                </Toolbar>
                </AppBar>
                {
          openSyncLogsFunctionDialog 
          &&
          <ViewUserSyncLogsFunctions 
            setOpenSyncLogsFunctionDialog = {setOpenSyncLogsFunctionDialog}
            openSyncLogsFunctionDialog = {openSyncLogsFunctionDialog}
            setSelectedUser = {setSelectedUser}
            selectedUser = {selectedUser}
          /> 
        }
            <div className={classes.appBarSpacer}></div>
            <div style={{padding:'.5rem'}}>
                {syncLogFunctionsLists()}
            </div>
      </Dialog>
      <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            </ThemeProvider>
      </StyledEngineProvider>
        </div>
    );
}

export default ViewUserDaysWithSyncLogsFunctions